import { render, staticRenderFns } from "./ChessButton.vue?vue&type=template&id=c7de29dc"
import script from "./ChessButton.vue?vue&type=script&lang=js"
export * from "./ChessButton.vue?vue&type=script&lang=js"
import style0 from "./ChessButton.vue?vue&type=style&index=0&id=c7de29dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports